import { queryOptions } from '@tanstack/react-query';
import { registerBaseURL } from '#constants/hosts';
import { client } from '#queries/utils';
import { ApiGetStakeholderResponse } from '#proto/qonto/registration/stakeholders/firstparty/v1/get_stakeholder';
import { ApiListStakeholdersResponse } from '#proto/qonto/registration/stakeholders/firstparty/v1/list_stakeholders';

export const membershipQueries = {
  all: ['register-memberships'] as const,
  list: (organizationId: string) =>
    queryOptions({
      queryKey: [...membershipQueries.all, 'list', organizationId] as const,
      queryFn: async () => {
        const json = await client(
          `${registerBaseURL}/v1/stakeholders?organization_id=${organizationId}`
        );

        return ApiListStakeholdersResponse.fromJSON(json);
      },
    }),
  item: (id: string) =>
    queryOptions({
      queryKey: [...membershipQueries.all, 'item', id] as const,
      queryFn: async () => {
        const json = await client(`${registerBaseURL}/v1/stakeholders/${id}`);

        return ApiGetStakeholderResponse.fromJSON(json);
      },
    }),
};
